// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".more-info-product[data-v-7c853190]{cursor:pointer}.container-base[data-v-7c853190]{display:flex}.container-card[data-v-7c853190]{border-radius:20px;display:flex;flex-direction:column;gap:5px;height:240px;width:220px}@media (min-width:1440px){.container-card[data-v-7c853190]{height:250px;width:250px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
